import {
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerServices from 'core/hooks/useCustomerServices';
import { useSchemaMeta } from 'Elements/Form/Schema';
import currency from 'Elements/Formats/currency';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import OverflowScroll from 'Elements/GridTable/OverflowScroll';

const Row = styled(GridRow)`
  grid-template-columns: 100px auto 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;

function CustomerServices({ location }: RouteComponentProps) {
  const { customerId } = useSchemaMeta<{ customerId: number }>();
  const { services, loading } = useCustomerServices(customerId);

  return (
    <Card elevation={1}>
      <CardHeader
        title="Työ- & tarvikehinnasto"
        action={
          <Button
            disabled={!customerId}
            component={Link}
            to={`${location.pathname}/services`}
            variant="contained"
            color="primary"
            size="small"
          >
            Päivitä
          </Button>
        }
      />
      <GridTable>
        <Header>
          <Row>
            <Column>Koodi</Column>
            <Column>Nimi</Column>
            <Column align="right">Hinta</Column>
          </Row>
        </Header>

        <Body>
          <OverflowScroll height="235px">
            {services &&
              services.length > 0 &&
              services.map((service) => (
                <Row hover>
                  <Column>{service.code}</Column>
                  <Column>{service.title}</Column>
                  <Column align="right">
                    {currency.format(service.pivot.price)}
                  </Column>
                </Row>
              ))}

            {loading && (
              <Row>
                <CenterColumn>
                  <CircularProgress />
                </CenterColumn>
              </Row>
            )}

            {!loading && (!services || services.length === 0) && (
              <Row>
                <CenterColumn>
                  <Typography variant="subtitle1">
                    Asiakkaalla ei ole työ- & tarvikehintoja.
                  </Typography>
                </CenterColumn>
              </Row>
            )}
          </OverflowScroll>
        </Body>
      </GridTable>
    </Card>
  );
}

export default withRouter(CustomerServices);
